/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { Button, filledInputClasses, Grid, Typography } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import MaterialTable from '@material-table/core';
import MainCard from '../../ui-component/cards/MainCard';
import SecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../store/constant';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Flatpickr from 'react-flatpickr';
import { Link } from 'react-router-dom';
import { Label } from 'reactstrap';

import uploadCloud from '../../assets/images/icons/cloud-upload-svgrepo-com.svg';
import moment from 'moment';

import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import IconCloudUpload from '@tabler/icons';

import { Divider, Input } from '@mui/material';
import axiosInstance from '../../axiosInstance';
import { useSelector } from 'react-redux';
import CardSecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import configData from '../../config';

const ManageSubscriptions = () => {
    const {
        control,
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm({
        defaultValues: {
            name: '',
            phone: '',
            email: '',
            password: ''
        }
    });

    const onSubmit = async (data) => {
        console.log(data);
        try {
            // const res = await axiosInstance.post('http://127.0.0.1:8000/organization/addSubscribersAccount', data);
            const res = await axiosInstance.post(configData.API_SERVER + '/organization/addSubscribersAccount', data);
            console.log(res);
            alert(res.data.message);
        } catch (error) {
            // Handle error
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log('Error response data:', error.response.data);
                console.log('Error response status:', error.response.status);

                // Check if the error is a result of email duplication
                if (error.response.status === 400 && error.response.data.message) {
                    // Display the error message to the user
                    alert(error.response.data.message);
                } else {
                    // Handle other types of errors accordingly
                    alert('Other error:', error.response.data);
                }
            } else if (error.request) {
                // The request was made but no response was received
                alert('Error request:', error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                alert('Error message:', error.message);
            }
        }
    };
    return (
        <React.Fragment>
            <MainCard style={{ color: ' ' }} title="Manage Subscriptions" secondary={<CardSecondaryAction />}>
                <Typography variant="subtitle1">Create Account for Subscribed Users</Typography>
                <form onSubmit={handleSubmit(onSubmit)} autoComplete="new-data">
                    <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                            <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                <Label style={{ fontSize: '14px !important' }}>
                                    Full Name<span style={{ color: 'red' }}>*</span>
                                </Label>
                            </Grid>
                            <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                <Input
                                    className="form-control "
                                    placeholder="Enter Name"
                                    {...register('name', { required: 'Name Is Required' })}
                                    defaultValue=""
                                />
                                {errors.name && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>{errors.name.message}</p>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                            <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                <Label style={{ fontSize: '14px !important' }}>
                                    Phone Number<span style={{ color: 'red' }}>*</span>
                                </Label>
                            </Grid>
                            <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                <Input
                                    type="number"
                                    className="form-control "
                                    placeholder="Enter Phone Number"
                                    {...register('phone', { required: 'Phone Number Is Required' })}
                                    autoComplete="new-password"
                                    defaultValue=""
                                />
                                {errors.phone && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>{errors.phone.message}</p>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                            <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                <Label style={{ fontSize: '14px !important' }}>
                                    Account Email<span style={{ color: 'red' }}>*</span>
                                </Label>
                            </Grid>
                            <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                <Input
                                    // type="text"
                                    className="form-control "
                                    placeholder="Enter Email"
                                    {...register('email', {
                                        required: 'Email Is Required',
                                        pattern: {
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                            message: 'Invalid email address'
                                        }
                                    })}
                                    autoComplete="new-password"
                                    defaultValue=""
                                />
                                {errors.email && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>{errors.email.message}</p>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                            <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                <Label style={{ fontSize: '14px !important' }}>
                                    Account Password<span style={{ color: 'red' }}>*</span>
                                </Label>
                            </Grid>
                            <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                <Input
                                    type="password"
                                    className="form-control "
                                    placeholder="Enter Password"
                                    {...register('password', { required: 'Password Is Required' })}
                                    autoComplete="new-password"
                                    defaultValue=""
                                />
                                {errors.password && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>{errors.password.message}</p>
                                )}
                            </Grid>
                        </Grid>
                        {/* License Dropdown Section */}
                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1">
                            <Grid lg={2} md={6} sm={12} xs={12} className="sad_Single">
                                <Label style={{ fontSize: '14px !important' }}>Licenses Assigned</Label>
                            </Grid>
                            <Grid lg={4} md={12} sm={12} xs={12} className="sad_Single">
                                <input
                                    type="number"
                                    className="form-control"
                                    {...register('licensesAssigned', { required: 'Please enter licenses assigned' })}
                                    placeholder="Enter Licenses Assigned"
                                />
                                {errors.licensesAssigned && (
                                    <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                        {errors.licensesAssigned.message}
                                    </p>
                                )}
                            </Grid>
                        </Grid>




                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid" style={{ marginTop: '-2rem' }}>
                            <Grid lg={4} sm={6} className="sad_Single">
                                <br></br>
                                <Button type="submit" variant="outlined" color="primary" style={{ marginTop: '10px', width: '50%' }}>
                                    Save Details
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>

                <Grid item xs={12} className="sub_div">
                    <Grid container spacing={gridSpacing}>
                        <Grid item lg={12} md={6} sm={6} xs={12}>
                            <Grid className="col-12 col-sm-12 text-center footer_inner_div">&copy; {new Date().getFullYear()} IMAGE-I</Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </MainCard>
        </React.Fragment>
    );
};

export default ManageSubscriptions;
